import { hotkeyHint } from "@/hooks/useCoverageBetaHotkeys";
import { useCoverageBetaStore } from "@/store/useCoverageBetaStore";
import { QUERY_IMAGE_CONTROL_ICON_SIZE } from "@/utils/utils";
import { Tooltip, ActionIcon } from "@mantine/core";
import { IconPointer } from "@tabler/icons-react";

export const CursorMode = () => {
  const activeMode = useCoverageBetaStore((s) => s.activeMode);
  const setActiveMode = useCoverageBetaStore((s) => s.setActiveMode);
  const recordInteraction = useCoverageBetaStore((s) => s.recordInteraction);

  return (
    <Tooltip label={`Cursor (${hotkeyHint("cursor")})`} position="right">
      <ActionIcon
        size="sm"
        variant={activeMode === "cursor" ? "filled" : "light"}
        color={activeMode === "cursor" ? "blue" : "gray"}
        onClick={() => {
          setActiveMode("cursor");
          recordInteraction("cursor", "click");
        }}
      >
        <IconPointer size={QUERY_IMAGE_CONTROL_ICON_SIZE} />
      </ActionIcon>
    </Tooltip>
  );
};
